'use es6';

import memoize from './memoize';
import * as Category from '../constants/groupTags/Category';
import * as SuperCategory from '../constants/groupTags/SuperCategory';
import * as SuperCategoryGroup from '../constants/groupTags/SuperCategoryGroup';
import * as CategorySlug from '../constants/urlSlugs/CategorySlug';
import * as SuperCategorySlug from '../constants/urlSlugs/SuperCategorySlug';
const superCategoryValues = Object.values(SuperCategory);
const getSuperCategoryGroupValues = memoize(superCategory => SuperCategoryGroup[superCategory]);
export const getCategorySuperCategory = memoize(category => {
  switch (category) {
    case Category.DATA_MANAGEMENT:
      return SuperCategory.MARKETING;

    case Category.LIVE_CHAT:
      return SuperCategory.MARKETING;

    case Category.VIDEO:
      return SuperCategory.MARKETING;

    default:
      return superCategoryValues.find(superCategory => {
        const superCategoryGroupValues = getSuperCategoryGroupValues(superCategory);
        return superCategoryGroupValues.includes(category);
      });
  }
});
export const getSuperCategoriesForCategory = memoize(category => {
  return superCategoryValues.filter(superCategory => {
    const superCategoryGroupValues = getSuperCategoryGroupValues(superCategory);
    return superCategoryGroupValues.includes(category);
  });
});
export const getAdminToolSlugDisplay = (category, slug) => {
  const superCategory = getCategorySuperCategory(category);
  return `/${SuperCategorySlug[superCategory]}/${CategorySlug[category]}/${slug}`;
};